import { serviceImageActionsFactory } from '../factories/serviceImageActionsFactory.ts';
import useAddInspectionServiceImage from './useAddInspectionServiceImage.ts';
import useRemoveInspectionServiceImage from './useRemoveInspectionServiceImage.ts';
import useInspectionServiceImages from './useInspectionServiceImages.ts';

export const useInspectionServiceImageActions = serviceImageActionsFactory({
  useAdd: useAddInspectionServiceImage,
  useRemove: useRemoveInspectionServiceImage,
  useImages: useInspectionServiceImages,
  queryKey: (id) => ['inspectionServices', id],
});
